import { render, staticRenderFns } from "./logoView.vue?vue&type=template&id=edad4e5c"
import script from "./logoView.vue?vue&type=script&lang=js"
export * from "./logoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports